<template>
  <div>
    <vs-card>
      <b-row class="justify-content-md-start">
        <b-col cols="3">
          <b-form-group label-for="item-name">
            <b-form-input
              v-model="arananDeger"
              id="smallInput"
              placeholder="Ara.."
              @keyup.enter="getStokList"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="auto" style="padding-left: 0px !important">
          <b-button
            style="background-color: #7367f0; border-color: white"
            size="sm"
            v-on:click="getStokList()"
            class="vs-con-loading__container"
            id="loading-stock-list"
          >
            <Icon
              icon="material-symbols:search-rounded"
              width="20"
              height="20"
            /> </b-button
        ></b-col>
        <b-col cols="12" md="auto" style="padding-left: 0px !important">
          <b-button
            style="background-color: #28c76f; border-color: white"
            size="sm"
            v-on:click="addStokList()"
          >
            <Icon icon="material-symbols:add-ad-outline" width="20" height="20" /> Yeni
            Ekle
          </b-button></b-col
        >
        <b-col cols="12" md="auto" style="padding-left: 0px !important">
          <b-button
            style="background-color: #7367f0; border-color: white"
            size="sm"
            v-on:click="addStokActWhole()"
          >
            <Icon icon="material-symbols:add-ad-outline" width="20" height="20" /> Toplu
            Stok Hareketi Ekle
          </b-button></b-col
        >
      </b-row>

      <ag-grid-vue
        style="width: 100%; height: 550px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowdata"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :pagination="true"
        @grid-ready="onMainGridReady"
        @first-data-rendered="onFirstDataRendered"
        :rowSelection="rowSelection"
        :masterDetail="true"
        :isRowMaster="isRowMaster"
        :detailCellRendererParams="detailCellRendererParams"
        :gridOptions="gridOptions"
      >
      </ag-grid-vue>
      {{ generalStockCount }}
      <b-pagination
        :value="1"
        :total-rows="totalStock"
        :per-page="pageLength"
        first-number
        last-number
        pills
        prev-class="prev-item"
        next-class="next-item"
        class="mt-1 mb-0"
        v-model="currentPage"
        @input="getStokList()"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
      <div class="d-flex align-items-center mb-0 mt-1">
        {{ totalStock }} adet kayıttan
        <span class="text-nowrap"> Gösterilen kayıt </span>
        <b-form-select
          v-model="pageLength"
          :options="['50', '100', '250', '500', '1000']"
          class="mx-1"
          v-on:change="getStockList()"
        />
      </div>
    </vs-card>

    <b-modal
      ref="modal-stoklistdetay"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Stok Detay"
      size="xl"
      hide-footer
    >
      <vs-card>
        <b-row>
          <b-col cols="6">
            <b-row style="margin-bottom: 50px">
              <b-col cols="4" style="padding-right: 0">
                <b-list-group>
                  <b-list-group-item
                    class="d-flex"
                    style="height: 50px"
                    variant="warning"
                  >
                    <span style="font-size: 13px">Stok Adı</span>
                  </b-list-group-item>
                  <b-list-group-item
                    class="d-flex"
                    style="height: 30px"
                    variant="warning"
                  >
                    <span style="font-size: 13px"> Stok Kodu </span>
                  </b-list-group-item>

                  <b-list-group-item
                    class="d-flex"
                    style="height: 30px"
                    variant="warning"
                  >
                    <span style="font-size: 13px">Barkod</span>
                  </b-list-group-item>
                  <!--

                  
                  <b-list-group-item
                    class="d-flex"
                    style="height: 30px;"
                    variant="warning"
                  >
                    <span style="font-size: 13px"> Ürün Kategorisi</span>
                  </b-list-group-item>
                  <b-list-group-item
                    class="d-flex"
                    style="height: 30px;"
                    variant="warning"
                  >
                    <span style="font-size: 13px"> Renk</span>
                  </b-list-group-item>-->
                </b-list-group>
              </b-col>
              <b-col cols="8" style="padding-left: 0">
                <b-list-group>
                  <b-list-group-item
                    class="d-flex"
                    style="height: 50px"
                    variant="warning"
                  >
                    <span style="font-size: 13px">{{ stokAdi }}</span>
                  </b-list-group-item>

                  <b-list-group-item class="d-flex" style="height: 30px">
                    <span style="font-size: 13px">{{ stokKodu }}</span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 30px">
                    <span style="font-size: 13px">{{ Barkod }}</span>
                  </b-list-group-item>
                  <!--
                  <b-list-group-item class="d-flex" style="height: 30px;">
                    <span style="font-size: 13px">{{ kategori1 }}</span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 30px;">
                    <span style="font-size: 13px">{{ renk }}</span>
                  </b-list-group-item>-->
                </b-list-group>
              </b-col>
            </b-row></b-col
          >
          <b-col>
            <b-row style="margin-bottom: 50px">
              <b-col cols="4" style="padding-right: 0">
                <b-list-group>
                  <!--
                  <b-list-group-item
                    class="d-flex"
                    style="height: 30px;"
                    variant="warning"
                  >
                    <span style="font-size: 13px"
                      ><b-row>
                        <b-col>
                          Beden
                        </b-col>
                      </b-row></span
                    >
                  </b-list-group-item>-->
                  <b-list-group-item
                    class="d-flex"
                    style="height: 30px"
                    variant="warning"
                  >
                    <span style="font-size: 13px"> Diğer Özellikler </span>
                  </b-list-group-item>

                  <b-list-group-item
                    class="d-flex"
                    style="height: 30px"
                    variant="warning"
                  >
                    <span style="font-size: 13px"> Ürün Açıklaması</span>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col cols="8" style="padding-left: 0">
                <b-list-group>
                  <b-list-group-item
                    class="d-flex"
                    style="height: 30px"
                    variant="warning"
                  >
                    <span style="font-size: 13px">{{ beden }}</span>
                  </b-list-group-item>

                  <b-list-group-item class="d-flex" style="height: 30px">
                    <span style="font-size: 13px">{{ gonderilenDetay }}</span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 50px">
                    <span style="font-size: 13px"></span>
                  </b-list-group-item>
                </b-list-group>
              </b-col> </b-row
          ></b-col>
        </b-row>
      </vs-card>
      <vs-divider></vs-divider>
      <vs-card
        v-if="stokDetayRowData"
        style="padding-right: 20px; margin-bottom: 5px !important"
      >
        <b-row style="margin-bottom: 0px !important; padding-bottom: 0px !important">
          <b-col cols="1" style="text-decoration: underline; color: #ea5455">Firma</b-col>
          <b-col style="text-decoration: underline; color: #ea5455" cols="2"
            >Stok Adı</b-col
          >
          <b-col cols="3" style="text-decoration: underline; color: #ea5455">
            <b-row>
              <b-col>Stok Kodu</b-col>
              <b-col>Barkod</b-col>
            </b-row>
          </b-col>

          <b-col style="text-decoration: underline; color: #ea5455" cols="3">
            <b-row>
              <b-col>Adet</b-col>
              <b-col>Fiyat</b-col>
              <b-col>Döviz</b-col>
              <b-col>Kdv</b-col>
            </b-row>
          </b-col>
          <b-col cols="2" style="text-decoration: underline; color: #ea5455">
            <b-row>
              <b-col>Kampanyalı Adet</b-col>
              <b-col>Kampanyalı Fiyat</b-col>
            </b-row>
          </b-col>
          <b-col cols="1" style="text-decoration: underline; color: #ea5455">
            İşlemler
          </b-col>
        </b-row>
      </vs-card>

      <div :class="scrollview">
        <div v-for="(item, index) in stokDetayRowData" :key="index">
          <vs-card
            style="margin-bottom: 5px !important"
            :style="
              item.oncelik == true
                ? 'margin-bottom: 5px !important; background-color: #ddf8e9;'
                : ''
            "
          >
            <b-row align-v="center">
              <b-col cols="1">
                <div style="overflow-wrap: anywhere">
                  {{ item.firma }}
                </div>
              </b-col>
              <b-col cols="2">
                <div style="overflow-wrap: anywhere">
                  {{ item.stokName }}
                </div>
              </b-col>
              <b-col cols="3">
                <b-row>
                  <b-col cols="6">
                    <div style="overflow-wrap: anywhere">
                      {{ item.stokKodu }}
                    </div>
                  </b-col>
                  <b-col cols="6">
                    <div style="overflow-wrap: anywhere">
                      {{ item.barkod }}
                    </div>
                  </b-col>
                </b-row>
              </b-col>

              <b-col cols="3">
                <b-row>
                  <b-col>{{ item.adet }}</b-col>

                  <b-col>{{
                    currencyFormatter(
                      item.fiyat,
                      item.doviz == "USD" ? "$" : item.doviz == "EUR" ? "€" : "₺"
                    )
                  }}</b-col>
                  <b-col>{{ item.doviz }}</b-col>
                  <b-col>{{ item.kdv }}</b-col>
                </b-row>
              </b-col>
              <b-col cols="2">
                <b-row>
                  <b-col cols="6">
                    <div style="overflow-wrap: anywhere">
                      {{ item.kampanyaAdet }}
                    </div>
                  </b-col>
                  <b-col cols="6">
                    <div style="overflow-wrap: anywhere">
                      {{
                        currencyFormatter(
                          item.kampanyaFiyat,
                          item.doviz == "USD" ? "$" : item.doviz == "EUR" ? "€" : "₺"
                        )
                      }}
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="1">
                <b-row>
                  <b-col cols="6" v-if="item.oncelik == true"
                    ><b-button
                      size="sm"
                      style="background-color: #7367f0; border-color: #7367f0"
                      v-on:click="
                        $refs['modal-kontrol'].show();
                        oncelikliItem = item;
                      "
                    >
                      <Icon
                        icon="mdi:priority-high"
                        width="20"
                        height="20"
                        v-b-tooltip.hover.bottom="'Öncelikli olarak işaretle'"
                      /> </b-button
                  ></b-col>

                  <b-col cols="6" v-else
                    ><b-button
                      size="sm"
                      variant="outline-light"
                      v-on:click="
                        $refs['modal-kontrol'].show();
                        oncelikliItem = item;
                      "
                    >
                      <Icon
                        icon="mdi:priority-high"
                        width="20"
                        height="20"
                        v-b-tooltip.hover.bottom="'Öncelikli olarak işaretle'"
                        color="#7367F0"
                      /> </b-button
                  ></b-col>
                  <b-col
                    cols="6"
                    v-if="item.oncelik == true"
                    style="padding: 0px !important"
                    ><b-button
                      size="sm"
                      v-on:click="kampanyaOlustur(item)"
                      style="background-color: #ff9f43; border-color: #ff9f43"
                    >
                      <Icon
                        icon="mdi:discount"
                        width="20"
                        height="20"
                        v-b-tooltip.hover.bottom="'Kampanya oluştur'"
                      /> </b-button
                  ></b-col>
                  <b-col cols="6" v-else style="padding: 0px !important"
                    ><b-button
                      size="sm"
                      variant="outline-light"
                      v-on:click="kampanyaOlustur(item)"
                    >
                      <Icon
                        icon="mdi:discount"
                        width="20"
                        height="20"
                        v-b-tooltip.hover.bottom="'Kampanya oluştur'"
                        color="#FF9F43"
                      /> </b-button
                  ></b-col>
                </b-row>
              </b-col>
            </b-row>
          </vs-card>
        </div>
      </div>
    </b-modal>
    <b-modal
      ref="modal-kampanyaEkle"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Kampanya Ekle"
      size="md"
      hide-footer
    >
      <div style="min-height: 350px">
        <vs-card>
          <div>
            <b-row>
              <b-col>
                <b-form-group label="Adet" label-for="item-name"
                  ><b-form-input id="stok-no" v-model="kampanyaAdet" /></b-form-group
              ></b-col>
              <b-col>
                <b-form-group label="Fiyat" label-for="item-name"
                  ><b-form-input id="stok-no" v-model="kampanyaTutat" /></b-form-group
              ></b-col>
              <b-col>
                <b-form-group label="Alış Fiyat" label-for="item-name"
                  ><b-form-input id="stok-no" v-model="alisFiyat" /></b-form-group
              ></b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Kampanya Başlangıç" label-for="item-name"
                  ><b-form-datepicker
                    id="kampanyaBaslangic"
                    v-model="kampanyaBaslangic"
                    size="md"
                    local="en"
                    class="mb-2"
                    today-variant="success"
                    placeholder="-"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }" /></b-form-group
              ></b-col>
              <b-col>
                <b-form-group label="Kampanya Bitiş" label-for="item-name"
                  ><b-form-datepicker
                    id="kampanyaBitis"
                    v-model="kampanyaBitis"
                    size="md"
                    local="en"
                    class="mb-2"
                    today-variant="success"
                    placeholder="-"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }" /></b-form-group
              ></b-col>
            </b-row>
          </div>

          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <b-button
                style="background-color: #ea5455; border-color: #ea5455"
                v-on:click="kampanyaKaydet('sil')"
              >
                <Icon
                  style="margin-right: 5px"
                  icon="ic:baseline-remove-circle"
                  width="20"
                  height="20"
                  v-b-tooltip.hover.bottom="'Kampanyayı Sil'"
                />Sil
              </b-button>
              <b-button
                style="background-color: #28c76f; border-color: #28c76f"
                v-on:click="kampanyaKaydet()"
              >
                <Icon
                  style="margin-right: 5px"
                  icon="mdi:content-save-check-outline"
                  width="20"
                  height="20"
                  v-b-tooltip.hover.bottom="'Kampanya oluştur'"
                />Kaydet
              </b-button>
            </vs-row>
          </div>
        </vs-card>
      </div>
    </b-modal>
    <b-modal
      ref="modal-resim"
      id="modal-primary"
      modal-class="modal-primary"
      size="sm"
      centered
      title="BootstrapVue"
      hide-footer
      hide-header
    >
      <img :src="imageLink" style="width: 100%" />
    </b-modal>
    <b-modal
      ref="modal-kontrol"
      id="modal-primary"
      modal-class="modal-primary"
      size="sm"
      centered
      title="Alış Fiyatu"
    >
      <div class="con-exemple-prompt">
        <span>Alış Fiyatı</span>
        <b-form-input
          v-model="alisFiyat2"
          id="smallInput"
          @keyup.enter="oncelikliOlarakIsaretle"
          size="sm"
        />
      </div>
      <template #modal-footer>
        <b-button
          style="background-color: #7367f0; border-color: white"
          size="sm"
          v-on:click="oncelikliOlarakIsaretle()"
        >
          <Icon icon="material-symbols:search-rounded" width="20" height="20" />Kaydet
        </b-button>
      </template>
    </b-modal>
    <vs-popup
      class="holamundo"
      title="Stok Hareketi"
      :active.sync="stockActPopup"
      fullscreen
    >
      <b-row>
        <b-col cols="4">
          <vs-card>
            <b-row>
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="'Stok Kodu'"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  disabled
                  v-model="stockCode"
                  type="text"
                  name="stockCode"
                  v-validate="'required'"
                  class="w-full"
                />
                <span class="text-danger text-sm" v-show="errors.has('stockCode')">{{
                  errors.first("stockCode")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="'Seri No - Koli No'"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="seriNo"
                  type="text"
                  name="seriNo"
                  class="w-full"
                />
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="'İşlem Türü'"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <v-select
                  color="danger"
                  v-model="islem"
                  :options="islem_choices"
                  size="small"
                  autocomplete
                  ref="selectElement"
                  name="islem"
                  v-validate="'required'"
                >
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('islem')">{{
                  errors.first("islem")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="'Tarih'"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <b-form-datepicker
                  id="baslangic"
                  v-model="stockTransDate"
                  size="sm"
                  placeholder="-"
                  name="stockTransDate"
                  style="width: 250px"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  v-validate="'required'"
                />

                <span class="text-danger text-sm" v-show="errors.has('stockTransDate')">{{
                  errors.first("stockTransDate")
                }}</span>
              </b-col>
            </b-row>
            <!--
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="'Adet'"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="quantity"
                  type="text"
                  name="quantity"
                  class="w-full"
                />
              </b-col>
            </b-row>
					-->
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="'Fiyat'"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="price"
                  type="text"
                  name="price"
                  v-validate="'required'"
                  class="w-full"
                />
                <span class="text-danger text-sm" v-show="errors.has('price')">{{
                  errors.first("price")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px" v-if="islem == 'Giriş'">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="'Giriş Adedi'"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="entryQuantity"
                  type="text"
                  name="entryQuantity"
                  v-validate="'required'"
                  class="w-full"
                />
                <span class="text-danger text-sm" v-show="errors.has('entryQuantity')">{{
                  errors.first("entryQuantity")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px" v-if="islem == 'Çıkış'">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="'Çıkış Adedi'"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="exitQuantity"
                  type="text"
                  name="exitQuantity"
                  v-validate="'required'"
                  class="w-full"
                />
                <span class="text-danger text-sm" v-show="errors.has('exitQuantity')">{{
                  errors.first("exitQuantity")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="'Açıklama'"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="description"
                  type="text"
                  name="description"
                  class="w-full"
                />
              </b-col>
            </b-row>
            <b-row class="justify-content-md-end" style="margin-top: 8px">
              <b-col cols="12" md="auto" style="padding-left: 0px !important">
                <b-button
                  style="background-color: #28c76f; border-color: white"
                  size="sm"
                  v-on:click="saveStockAct()"
                >
                  <Icon icon="material-symbols:add-ad-outline" width="20" height="20" />
                  Kaydet
                </b-button></b-col
              >
            </b-row>
          </vs-card>
        </b-col>
        <b-col>
          <vs-card>
            <ag-grid-vue
              style="width: 100%; height: 400px; margin-top: 25px"
              class="ag-theme-alpine"
              :suppressRowClickSelection="true"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefsAct"
              :rowData="rowdataAct"
              :localeText="localeText"
              @grid-ready="onGridReady"
              @first-data-rendered="onFirstDataRenderedAct"
              :rowSelection="rowSelectionAct"
            >
            </ag-grid-vue>
          </vs-card>
        </b-col>
      </b-row>
    </vs-popup>
    <vs-popup class="holamundo" title="Stok Hareketi" :active.sync="addStokActWholePopup">
      <b-row align-v="center">
        <b-col>
          Örnek Excel Şablonu
          <a
            :href="'http://sistem.uzum.com.tr/assets/StokHareketOrnekSablon.xlsx'"
            download
            >İNDİR</a
          >
          <input type="file" @change="onChange" id="xmlListForExcel" />
        </b-col>

        <b-col style="text-align: center">
          <vs-button
            style="border-radius: 5px"
            variant="primary"
            v-on:click="wholeActSave()"
          >
            Stok Hareketlerini Kaydet
          </vs-button>
        </b-col>
      </b-row>
      <b-row>
        <ag-grid-vue
          style="width: 100%; height: 400px; margin-top: 15px"
          class="ag-theme-alpine"
          :enableCellChangeFlash="true"
          :animateRows="true"
          :defaultColDef="defaultColDef"
          :columnDefs="columnDefsForExcel"
          :rowData="wholeActList"
          :localeText="localeText"
          :suppressCopyRowsToClipboard="true"
          :pagination="true"
        >
        </ag-grid-vue>
      </b-row>
    </vs-popup>
    <vs-prompt
      title="Sipariş Onayı"
      acceptText="Onayla"
      cancelText="Vazgeç"
      @accept="deleteStockAct"
      :active.sync="activePrompt"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span>Silme işlemini onaylıyor musunuz? </span>
      </div>
    </vs-prompt>
    <AddXmlStockList
      :isPopupActive="isXmlAddPopupActive"
      @closeSidebar="toggleDataSidebar"
      :data="xmlStokDetay"
    />
  </div>
</template>
<script>
import { Validator } from "vee-validate";
import TedarikciOncelikButon from "../components/uzum-components/stoklistesi-components/TedarikciOncelikButon";
import { Icon } from "@iconify/vue2";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import state from "../../store/state";
import Store from "../../store/store";
import StokGoruntuleButon from "../components/uzum-components/stoklistesi-components/StokGoruntuleButon.vue";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
import StokListDetayButon from "../components/uzum-components/stoklistesi-components/StokListDetayButon.vue";
import AddXmlStockList from "../components/uzum-components/stoklistesi-components/AddXmlStockList.vue";
import stockActButtons from "../components/uzum-components/stoklistesi-components/stockActButtons.vue";
import vSelect from "vue-select";
import XLSX from "xlsx";
import { fixTurkishCharsDeep } from "../../helpers/fixTurkishChars";
export default {
  data() {
    return {
      currentPage: 1,
      pageLength: 50,
      totalStock: 0,
      generalStockCount: "",
      ekYetkiler: "",
      activePrompt: false,
      deletedStock: [],
      gridOptions: {
        pagination: true,
        paginationPageSize: 20,
      },
      xmlListForExcel: "",
      columnDefsForExcel: null,
      wholeActList: [],
      addStokActWholePopup: false,
      islem_choices: ["Giriş", "Çıkış"],
      islem: "",
      columnDefsAct: [],
      rowdataAct: [],
      stockCode: "",
      seriNo: "",
      description: "",
      stockTransDate: "",
      quantity: "",
      price: "",
      exitQuantity: "",
      entryQuantity: "",
      stockActPopup: false,
      xmlStokDetay: [],
      isXmlAddPopupActive: false,
      getRowId: null,
      isRowMaster: null,
      detailCellRendererParams: null,
      oncelikliItem: "",
      alisFiyat2: 0.0,
      alisFiyat: 0.0,
      imageLink: "",
      scrollview: "",
      kampanyaBaslangic: "",
      kampanyaBitis: "",
      kampanyaAdet: 0,
      kampanyaTutat: 0.0,
      xmlDetayBarkod: [],
      KAYITSAYISI: 0,
      stokAdi: "",
      stokKodu: "",
      Barkod: "",
      kategori1: "",
      renk: "",
      beden: "",
      gonderilenDetay: "",
      stokDetayRowData: null,
      arananDeger: "",
      rowSelection: null,
      rowSelectionAct: null,
      rowdata: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      localeText: null,
      columnDefs: null,
      kampanyaItem: [],
      gridAnaParams: null,
    };
  },
  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.rowSelection = "single";
    this.scrollview = "scroll-hand";
    this.getStokList();
    this.ekYetkiler = this.$store.state.ekYetkiler;
    if (this.ekYetkiler == "depo") this.islem_choices = ["Giriş"];
    const dict = {
      custom: {
        valid: {
          required: "Gereklidir",
        },
      },
    };

    Validator.localize("en", dict);
  },
  components: {
    stockActButtons,
    vSelect,
    AddXmlStockList,
    TedarikciOncelikButon,
    StokGoruntuleButon,
    Icon,
    AgGridVue,
    TextGorunumCellRenderer,
    StokListDetayButon,
  },
  methods: {
    onFilterChanged() {
      try {
        this.generalStockCount = this.gridApi.getDisplayedRowCount();
      } catch (error) {
        console.log(error);
      }
    },
    wholeActSave() {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        isDue: "wholeInsert",
        stockActList: JSON.stringify(vm.wholeActList),
      };
      try {
        soap.createClient(url, function (err, client) {
          client.stockAct(args, function (err, result) {
            if (result.stockActResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            let donus = fixTurkishCharsDeep(JSON.parse(result.stockActResult));
            if (donus.response == "Ok")
              vs.notify({
                text: "Kaydedildi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            else
              vs.notify({
                text: "Exceli tekrar kontrol ediniz " + response.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
          });
        });
      } catch (error) {
        console.log(error);
        vs.notify({
          text: error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
      }
    },
    onChange(e) {
      const vm = this;
      vm.wholeActList = [];
      var files = e.target.files,
        f = files[0];
      var reader = new FileReader();
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array", cellDates: true });
        let sheetName = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[sheetName];
        vm.wholeActList = XLSX.utils.sheet_to_json(worksheet);
        vm.setItems();
      };
      reader.readAsArrayBuffer(f);
    },
    setItems(items) {
      this.columnDefsForExcel = [];
      let list = this.wholeActList[0];
      let columnList = Object.keys(list);
      columnList.forEach((val, index) => {
        if (val !== "Resim") {
          this.columnDefsForExcel.push({
            field: val,
            filter: "agSetColumnFilter",
            wrapText: true,
            autoHeight: true,
          });
        }
      });
    },
    addStokActWhole() {
      this.wholeActList = [];
      document.getElementById("xmlListForExcel").value = "";
      this.addStokActWholePopup = true;
    },
    deleteStockAct(param) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        actId: param.actId,
        isDue: "delete",
      };

      soap.createClient(url, function (err, client) {
        client.stockAct(args, function (err, result) {
          if (result.stockActResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          let verilerStockAct = fixTurkishCharsDeep(JSON.parse(result.stockActResult));
          vm.description = "";
          vm.stockTransDate = "";
          vm.exitQuantity = "";
          vm.entryQuantity = "";
          vm.listStockAct();
        });
      });
    },
    listStockAct() {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        stockCode: vm.stockCode,
      };
      try {
        soap.createClient(url, function (err, client) {
          client.stockActList(args, function (err, result) {
            if (result.stockActListResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            let listAct = [];

            listAct = fixTurkishCharsDeep(JSON.parse(result.stockActListResult));
            vm.rowdataAct = listAct;
            vm.columnDefsAct = [];

            vm.columnDefsAct = [
              {
                field: "stockCode",
                filter: "agSetColumnFilter",
                headerName: "Stok Kodu",
              },
              {
                field: "seriNo",
                filter: "agSetColumnFilter",
                headerName: "Seri No - Koli No",
              },
              { field: "price", filter: "agSetColumnFilter", headerName: "Fiyat" },
              /*   { field: "quantity", filter: "agSetColumnFilter", headerName: "Adet" },*/
              {
                field: "entryQuantity",
                filter: "agSetColumnFilter",
                headerName: "Giriş Adet",
              },
              {
                field: "exitQuantity",
                filter: "agSetColumnFilter",
                headerName: "Çıkış Adet",
              },
              {
                field: "stockTransDate",
                filter: "agSetColumnFilter",
                headerName: "Tarih",
              },
            ];
            if (vm.ekYetkiler != "depo") {
              vm.columnDefsAct.push({
                width: 120,
                cellRendererFramework: "stockActButtons",
                wrapText: true,
                autoHeight: true,
              });
            }
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    saveStockAct() {
      var vs = this.$vs;
      this.$validator.validateAll().then((result) => {
        if (result) {
          var vm = this;
          const soap = require("soap");
          const url = state.sistemAddress;
          const args = {
            token: Store.state.tokenId,
            isDue: "insert",
            stockCode: vm.stockCode,
            seriNo: vm.seriNo,
            stockTransDate: vm.stockTransDate,
            quantity: vm.quantity,
            price: vm.price,
            exitQuantity: vm.exitQuantity,
            entryQuantity: vm.entryQuantity,
            description: vm.description,
          };
          soap.createClient(url, function (err, client) {
            client.stockAct(args, function (err, result) {
              if (result.stockActResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }
              let verilerStockAct = fixTurkishCharsDeep(JSON.parse(result.stockActResult));
              vm.description = "";
              vm.stockTransDate = "";
              vm.exitQuantity = "";
              vm.entryQuantity = "";
              vm.listStockAct();
            });
          });
        } else {
          vs.notify({
            text: "Zorunlu alanları doldurunuz",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },
    addStockAct(param) {
      this.stockActPopup = true;
      this.stockCode = param.stokKodu;
      this.seriNo = param.seriNo;
      this.quantity = param.StokAdet;
      this.price = param.SATIS_FIAT1;
      this.listStockAct();
    },
    deleteEslesenStok(param) {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        firma: vm.deletedStock.firma,
        stokkodu: vm.deletedStock.stokKodu,
      };
      soap.createClient(url, function (err, client) {
        client.UzumStokSil(args, function (err, result) {
          if (result.UzumStokSilResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = fixTurkishCharsDeep(JSON.parse(result.UzumStokSilResult));
          vm.getStokList();
          vm.isXmlAddPopupActive = false;
        });
      });
    },
    toggleDataSidebar(val = false) {
      this.isXmlAddPopupActive = val;
    },
    oncelikOlusturBtn(data) {
      this.$refs["modal-kontrol"].show();
      this.oncelikliItem = data;
    },
    getStokResim(data) {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        pazaryeri: "Ticimax",
        stokKodu: data.stokKodu,
      };
      soap.createClient(url, function (err, client) {
        client.resimUrlCek(args, function (err, result) {
          if (result.resimUrlCekResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.resimUrlCekResult);
          vm.imageLink = vm.veriler.jsonData.resimUrl;
          vm.$refs["modal-resim"].show();
        });
      });
    },
    handscroll(el) {},
    currencyFormatter(currency, sign) {
      if (typeof currency == "undefined" || currency == null) return 0;
      var gelencurr = parseFloat(currency);
      var sansDec = gelencurr.toFixed(2);
      var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return sign + `${formatted}`;
    },
    kampanyaKaydet(sil) {
      var vs = this.$vs;
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url =
        state.sistemAddress; /*
      if (vm.kampanyaBaslangic == "") {
        vs.notify({
          title: "Kampanya Ekleme",
          text: "Kampanya Başlangıç Tarihi Bilgisi Zorunludur",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else if (vm.kampanyaBitis == "") {
        vs.notify({
          title: "Kampanya Ekleme",
          text: "Kampanya Bitiş Tarihi Bilgisi Zorunludur",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else if (vm.kampanyaAdet == 0 || vm.kampanyaAdet == "") {
        vs.notify({
          title: "Kampanya Ekleme",
          text: "Kampanya Adet Bilgisi Zorunludur",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else if (vm.kampanyaTutat == 0.0 || vm.kampanyaTutat == "") {
        vs.notify({
          title: "Kampanya Ekleme",
          text: "Kampanya Tutar Tarihi Bilgisi Zorunludur",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {*/
      let args = {};
      if (sil == "sil") {
        args = {
          token: Store.state.tokenId,
          pazaryeriKod:
            typeof vm.kampanyaItem.pazaryeriKod == "undefined"
              ? vm.xmlDetayBarkod.stokKodu
              : vm.kampanyaItem.pazaryeriKod,
          stokId: vm.kampanyaItem.stokId,
          kampanyaBaslangic: "",
          kampanyaBitis: "",
          kampanyaAdet: 0,
          kampanyaFiyat: 0.0,
          alisFiyat: 0.0,
        };
      } else {
        args = {
          token: Store.state.tokenId,
          pazaryeriKod:
            typeof vm.kampanyaItem.pazaryeriKod == "undefined"
              ? vm.xmlDetayBarkod.stokKodu
              : vm.kampanyaItem.pazaryeriKod,
          stokId: vm.kampanyaItem.stokId,
          kampanyaBaslangic: vm.kampanyaBaslangic,
          kampanyaBitis: vm.kampanyaBitis,
          kampanyaAdet: vm.kampanyaAdet,
          kampanyaFiyat: vm.kampanyaTutat,
          alisFiyat: vm.alisFiyat,
        };
      }
      soap.createClient(url, function (err, client) {
        client.oncelikliStokGuncelle(args, function (err, result) {
          if (result.oncelikliStokGuncelleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = fixTurkishCharsDeep(JSON.parse(result.oncelikliStokGuncelleResult));
          vm.kampanyaBaslangic = "";
          vm.kampanyaBitis = "";
          vm.kampanyaAdet = 0;
          vm.kampanyaTutat = 0.0;
          vm.getStokList();
          //	vm.getxmlStokList(vm.xmlDetayBarkod);
          vm.$refs["modal-kampanyaEkle"].hide();
        });
      });
      // }
    },
    kampanyaOlustur(item) {
      this.$refs["modal-kampanyaEkle"].show();
      this.kampanyaItem = item;
      if (this.kampanyaItem.kampanyaBaslangic != "1900-01-01T00:00:00")
        this.kampanyaBaslangic = this.kampanyaItem.kampanyaBaslangic;
      if (this.kampanyaItem.kampanyaBitis != "1900-01-01T00:00:00")
        this.kampanyaBitis = this.kampanyaItem.kampanyaBitis;
      this.kampanyaAdet = this.kampanyaItem.kampanyaAdet;
      this.kampanyaTutat = this.kampanyaItem.kampanyaFiyat;
    },
    oncelikliOlarakIsaretle(item) {
      var vm = this;
      var vs = this.$vs;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.alisFiyat2 == "") {
        vs.notify({
          title: "Alış Fiyatı zorunludur",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        const args = {
          token: Store.state.tokenId,
          pazaryeriKod:
            typeof vm.kampanyaItem.pazaryeriKod == "undefined"
              ? vm.xmlDetayBarkod.stokKodu
              : vm.kampanyaItem.pazaryeriKod,
          stokId: vm.oncelikliItem.stokId,
          kampanyaFiyat: vm.oncelikliItem.fiyat,
          alisFiyat: vm.alisFiyat2,
          kampanyaAdet: 0,
        };
        soap.createClient(url, function (err, client) {
          client.oncelikliStokGuncelle(args, function (err, result) {
            if (result.oncelikliStokGuncelleResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = fixTurkishCharsDeep(JSON.parse(result.oncelikliStokGuncelleResult));
            //	vm.getxmlStokList(vm.xmlDetayBarkod);
            vm.getStokList();
            vm.$refs["modal-kontrol"].hide();
          });
        });
      }
    },
    onMainGridReady(params) {
      this.gridAnaParams = params; // params'ı kaydediyoruz
      //     this.setupDatasource();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRenderedAct(params) {
      params.api.sizeColumnsToFit();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    addStokList(param) {
      this.xmlStokDetay = param;
      this.isXmlAddPopupActive = true;
    },
    getStokList() {
      var vm = this;
      var vs = this.$vs;
      let type = "material";
      setTimeout(() => {
        vs.loading({
          container: `#loading-stock-list`,
          type,
          scale: 0.5,
        });
      }, 500);
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        kod: vm.arananDeger,
        AktifPazarYeriTanim: "filter",
        pageSize: vm.pageLength,
        page: vm.searching != "" ? 1 : vm.currentPage,
      };
      try {
        soap.createClient(url, function (err, client) {
          client.stokListesi(args, function (err, result) {
            if (result.stokListesiResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            setTimeout(() => {
              vs.loading.close("#loading-stock-list > .con-vs-loading");
            }, 1000);
            vm.veriler = fixTurkishCharsDeep(JSON.parse(result.stokListesiResult));
            vm.rowdata = vm.veriler;
            vm.generalStockCount = vm.rowdata.length;
            vm.totalStock = vm.rowdata[0].kayitSayisi;
            //     vm.gridParams.successCallback(vm.rowdata, vm.rowdata.kayitSayisi);
            // detay bu serviste alt urun listesi JSON'u olarak gelebiliyor,
            // stokListesi semasinda ise duz metin; parse edilemiyorsa master/detail bos kalir
            vm.rowdata.forEach((val) => {
              try {
                const cozulen = JSON.parse(val.detay);
                val.detay = Array.isArray(cozulen) ? cozulen : [];
              } catch (error) {
                val.detay = [];
              }
            });

            vm.isRowMaster = (dataItem) => {
              return dataItem ? dataItem.detay.length > 0 : false;
            };
            vm.detailCellRendererParams = {
              detailGridOptions: {
                rowSelection: "multiple",
                suppressRowClickSelection: true,
                enableRangeSelection: true,
                pagination: false,
                paginationAutoPageSize: false,
                columnDefs: [
                  { headerName: "Firma", field: "program" },
                  { headerName: "Xml Kodu", field: "muhasebeKod" },
                  { headerName: "Pazaryeri Kodu", field: "pazaryeriKod" },
                  { headerName: "Barkodu", field: "barcode" },
                  {
                    width: 100,
                    field: "",
                    cellRendererFramework: "TedarikciOncelikButon",
                    wrapText: true,
                    autoHeight: true,
                  },
                ],
                defaultColDef: {
                  sortable: true,
                  flex: 1,
                },
              },
              getDetailRowData: (params) => {
                params.successCallback(params.data.detay);
              },
            };
          });
        });
      } catch (error) {
        setTimeout(() => {
          vs.loading.close("#loading-stock-list > .con-vs-loading");
        }, 1000);
      }
    },
    getxmlStokList(stokDetayVal) {
      this.$refs["modal-stoklistdetay"].show();
      var vm = this;
      vm.xmlDetayBarkod = stokDetayVal;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        barcode: stokDetayVal.stokKodu,
      };
      soap.createClient(url, function (err, client) {
        client.xmlStokListesi(args, function (err, result) {
          if (result.xmlStokListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = fixTurkishCharsDeep(JSON.parse(result.xmlStokListesiResult));
          vm.stokDetayRowData = vm.veriler.jsonData;
          vm.stokAdi = stokDetayVal.StokAdi;
          vm.stokKodu = stokDetayVal.stokKodu;
          vm.Barkod = stokDetayVal.Barkod;
          vm.kategori1 = stokDetayVal.kategori1;
          vm.renk = stokDetayVal.renk;
          vm.beden = stokDetayVal.beden;
          vm.gonderilenDetay = stokDetayVal.gonderilenDetay;
        });
      });
    },
    addXmlStock(param) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      let args = {
        token: Store.state.tokenId,
        firma: param.firma,
        stokName: param.stokName,
        ortakKod: param.ortakKod,
        ortakKodName: param.ortakKodName,
        stokKodu: param.stokKodu,
        barkod: param.barkod,
        barkod2: param.barkod2,
        adet: param.adet,
        fiyat: param.fiyat,
        satisFiyat: param.satisFiyat,
        maliyet: param.maliyet,
        doviz: param.doviz,
        kdv: param.kdv,
        beden: param.beden,
        renk: param.renk,
        aciklama: param.aciklama,
        kategori: param.kategori,
        marka: param.marka,
        kargoSuresi: param.kargoSuresi,
        alan1: param.alan1,
        alan2: param.alan2,
        alan3: param.alan3,
      };
      if (param.edit == "edit") {
        soap.createClient(url, function (err, client) {
          client.UzumStokGuncelle(args, function (err, result) {
            if (result.UzumStokGuncelleResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = fixTurkishCharsDeep(JSON.parse(result.UzumStokGuncelleResult));
            vm.getStokList();
            vm.isXmlAddPopupActive = false;
          });
        });
      } else
        soap.createClient(url, function (err, client) {
          client.UzumStokEkle(args, function (err, result) {
            if (result.UzumStokEkleResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = fixTurkishCharsDeep(JSON.parse(result.UzumStokEkleResult));
            vm.getStokList();
            vm.isXmlAddPopupActive = false;
          });
        });
    },
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("getxmlStokList", (stokDetayVal) => {
      this.getxmlStokList(stokDetayVal);
    });
    this.$root.$on("getStokResim", (stokDetayVal) => {
      this.getStokResim(stokDetayVal);
    });
    this.$root.$on("oncelikOlusturBtn", (stokDetayVal) => {
      this.oncelikOlusturBtn(stokDetayVal);
    });
    this.$root.$on("kampanyaOlustur", (stokDetayVal) => {
      this.kampanyaOlustur(stokDetayVal);
    });
    this.$root.$on("addXmlStock", (param) => {
      this.addXmlStock(param);
    });
    this.$root.$on("addStokList", (param) => {
      this.addStokList(param);
    });
    this.$root.$on("deleteEslesenStok", (param) => {
      this.deletedStock = param;
      this.activePrompt = true;
    });
    this.$root.$on("addStockAct", (param) => {
      this.addStockAct(param);
    });
    this.$root.$on("deleteStockAct", (param) => {
      this.deleteStockAct(param);
    });
  },
  beforeDestroy() {
    this.$root.$off("getxmlStokList");
    this.$root.$off("getStokResim");
    this.$root.$off("oncelikOlusturBtn");
    this.$root.$off("kampanyaOlustur");
    this.$root.$off("addXmlStock");
    this.$root.$off("addStokList");
    this.$root.$off("deleteEslesenStok");
    this.$root.$off("addStockAct");
    this.$root.$off("deleteStockAct");
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 200,
        field: "",
        cellRendererFramework: "StokGoruntuleButon",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Firma",
        field: "firma",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Firma Stok Kodu",
        field: "muhasebeKod",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        cellRenderer: "agGroupCellRenderer",
        headerName: "Stok Kodu",
        field: "stokKodu",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Barkod",
        sortable: true,
        filter: "agSetColumnFilter",
        field: "Barkod",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Stok Adı",
        field: "stokName",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Renk",
        field: "renk",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Satış Fiyatı",
        field: "SATIS_FIAT1",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Liste Fiyat",
        field: "LISTE_FIAT",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Maliyet",
        field: "maliyet",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Stok Adet",
        field: "stokAdet",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        width: 100,
        field: "",
        cellRendererFramework: "StokListDetayButon",
        wrapText: true,
        autoHeight: true,
      },
    ];
  },
};
</script>
<style lang="scss">
.scroll-hand {
  max-height: 260px;
  overflow-y: auto;
  overflow-x: hidden;
}

.vs-card--content {
  margin-bottom: 5px !important;
}

#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir] .modal-title {
  margin-bottom: 0;
  color: #7367f0 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.vuesax-app-is-ltr .con-vs-dialog {
  z-index: 111111 !important;
}

.my-fancy-class {
  background-color: #7367f0;
}

#main {
  width: 200px;
  height: 200px;
  border: 1px solid #c3c3c3;
  display: flex;
  flex-wrap: wrap;
}

#main div {
  width: 50px;
  height: 50px;
}
</style>
